import { post } from '../../../../shared/js/json-fetch'
import Dialog from '../shared/Dialog'
import ToggablePassword from '../shared/ToggablePassword'
import SignupForm from './SignupForm'
import { Turnstile } from '@marsidev/react-turnstile'
import React, { useRef, useState } from 'react'
import { useFormStatus } from 'react-dom'
import type { FlashProps } from '../../shared/Module'
import type { TurnstileInstance } from '@marsidev/react-turnstile'
import type { SyntheticEvent } from 'react'

type LoginFormProps = {
  customer?: CustomerProps
  loginUrl?: string
  registrationUrl?: string
  forgotPasswordUrl?: string
  rememberable?: boolean
  turnstileSiteKey?: string
}

type CustomerProps = {
  accountUrl: string
  logoutUrl: string
  fullName: string
  email: string
}

// TODO: affichage de validation de connexion
export default function LoginForm({
  loginUrl,
  registrationUrl,
  rememberable,
  forgotPasswordUrl,
  turnstileSiteKey,
  customer: loggedInCustomer,
}: LoginFormProps) {
  const { pending } = useFormStatus()
  const [customer, setCustomer] = useState<CustomerProps | null>(
    loggedInCustomer
  )
  const [flash, setFlash] = useState<FlashProps | null>(null)
  const [active, setActive] = useState(false)
  const turnstileRef = useRef<TurnstileInstance | null>(null)

  return (
    <>
      <a
        role='button'
        className='lb-btn lb-btn-naked user-btn'
        onClick={toggleDialog}
      >
        <span>
          {customer ? customer.fullName || customer.email : 'Mon compte'}
        </span>
      </a>

      <Dialog
        className='right-action-modal'
        onCancel={toggleDialog}
        opened={active}
        title='Mon compte'
      >
        {customer ? (
          <div className='customer-logged-in'>
            <p>
              {customer.fullName ? `${customer.fullName}, que` : 'Que'}{' '}
              souhaitez-vous faire ?
            </p>

            <a className='lb-btn lb-btn-type-1' href={customer.accountUrl}>
              Accéder à mon espace
            </a>
            <button className='lb-btn lb-btn-type-2' onClick={toggleDialog}>
              Continuer ma navigation
            </button>

            {customer.logoutUrl && (
              <p>
                <a href={customer.logoutUrl}>Me déconnecter</a>
              </p>
            )}
          </div>
        ) : (
          <>
            <form
              action={handleLogin}
              id='customer-sign-in'
              className='c-signin--account'
              // honeypot
            >
              <p>J’ai déjà un compte, je me connecte :</p>
              <p className='field'>
                <input
                  name='email'
                  id='email'
                  type='email'
                  placeholder=' '
                  autoComplete='email'
                  aria-required
                  required
                />
                <label htmlFor='email'>E-mail</label>
              </p>

              <ToggablePassword
                id='signin-pass'
                name='password'
                label='Mot de passe'
                containerClassName='field'
              />

              {rememberable && (
                <p>
                  <input id='remember_me' type='checkbox' name='remember_me' />
                  <label htmlFor='remember_me'>Se souvenir de moi</label>
                </p>
              )}
              {forgotPasswordUrl && (
                <div className='c-signin__link'>
                  <a href={forgotPasswordUrl} className='c-link c-link--icon'>
                    J’ai oublié mon mot de passe
                  </a>
                </div>
              )}
              {turnstileSiteKey && (
                <Turnstile ref={turnstileRef} siteKey={turnstileSiteKey} />
              )}
              <button
                className='lb-btn lb-btn-type-1'
                type='submit'
                disabled={pending}
              >
                {pending ? 'Connexion…' : 'Me connecter'}
              </button>
            </form>
            {flash && (
              <span className={`u-mb-2 c-message c-message--${flash.kind}`}>
                {Array.isArray(flash.message)
                  ? flash.message.map((msg) => (
                      <>
                        {msg}
                        <br />
                      </>
                    ))
                  : flash.message}
              </span>
            )}

            <SignupForm
              registrationUrl={registrationUrl}
              setCustomer={setCustomer}
              turnstileSiteKey={turnstileSiteKey}
            />
          </>
        )}
      </Dialog>
    </>
  )

  async function handleLogin(formData: any) {
    const email = formData.get('email')
    const password = formData.get('password')
    const rememberMe = formData.get('remember_me')
    const turnstileToken = turnstileRef.current?.getResponse()

    if (!loginUrl) return

    const { customer, flash } = await post(loginUrl, {
      cf_turnstile_response: turnstileToken,
      customer: {
        email,
        password,
        remember_me: rememberMe,
      },
    })

    setFlash(flash)
    setCustomer(customer)
    turnstileRef.current?.reset() // Reset after submission
  }

  function toggleDialog(event?: SyntheticEvent) {
    event?.preventDefault()
    setActive(!active)
  }
}
